// NFL supplements — extended valuation history (1998-2018) + factor narratives
// Sources: Forbes annual NFL valuations 1998-2018, Sportico, ESPN, SBJ
// Note: Forbes began publishing NFL franchise valuations in 1998. Values in $B.
// Where Forbes year-specific data is approximated rather than directly cited, isEstimated: true is set.

export const nflSupplements = {

  "Buffalo Bills": {
    extendedValuationHistory: [
      { year: 1998, value: 0.247, source: "Forbes" },
      { year: 1999, value: 0.310, source: "Forbes" },
      { year: 2000, value: 0.341, source: "Forbes" },
      { year: 2001, value: 0.386, source: "Forbes" },
      { year: 2002, value: 0.449, source: "Forbes" },
      { year: 2003, value: 0.509, source: "Forbes" },
      { year: 2004, value: 0.629, source: "Forbes" },
      { year: 2005, value: 0.683, source: "Forbes" },
      { year: 2006, value: 0.756, source: "Forbes" },
      { year: 2007, value: 0.821, source: "Forbes" },
      { year: 2008, value: 0.885, source: "Forbes" },
      { year: 2009, value: 0.799, source: "Forbes" },
      { year: 2010, value: 0.799, source: "Forbes" },
      { year: 2011, value: 0.792, source: "Forbes" },
      { year: 2012, value: 0.825, source: "Forbes" },
      { year: 2013, value: 0.870, source: "Forbes" },
      { year: 2014, value: 1.40, source: "Forbes / 2014 Pegula sale at $1.4B" },
      { year: 2015, value: 1.50, source: "Forbes" },
      { year: 2016, value: 1.50, source: "Forbes" },
      { year: 2017, value: 1.60, source: "Forbes" },
      { year: 2018, value: 1.60, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Bills receive ~$340M/year from the NFL's national TV deal — the equal-share structure of the 11-year 2023-2033 contract is the foundational valuation driver across all 32 franchises and provides a hard floor independent of market or performance.",
      stadium: "Highmark Stadium (1973) is publicly owned by NY State and lacks premium revenue infrastructure; new $1.54B stadium opening 2026 with $850M public funding is transformative for premium seating, naming rights, and non-game event income.",
      brand: "Mid-tier NFL brand with passionate regional 'Bills Mafia' fanbase; Josh Allen era drove national prominence, merchandise growth, and primetime exposure from a historically blue-collar Buffalo identity.",
      marketSize: "Buffalo DMA #54 is one of the smallest in the NFL, but the franchise functions as a regional brand spanning Western NY and parts of Southern Ontario with no in-market competition.",
      onField: "Six straight playoff appearances under Josh Allen culminating in his $330M extension (March 2025); contender status translated into stadium support, sponsorship growth, and franchise-record revenue."
    }
  },

  "Miami Dolphins": {
    extendedValuationHistory: [
      { year: 1998, value: 0.340, source: "Forbes" },
      { year: 1999, value: 0.446, source: "Forbes" },
      { year: 2000, value: 0.446, source: "Forbes" },
      { year: 2001, value: 0.524, source: "Forbes" },
      { year: 2002, value: 0.602, source: "Forbes" },
      { year: 2003, value: 0.659, source: "Forbes" },
      { year: 2004, value: 0.726, source: "Forbes" },
      { year: 2005, value: 0.772, source: "Forbes" },
      { year: 2006, value: 0.846, source: "Forbes" },
      { year: 2007, value: 0.942, source: "Forbes" },
      { year: 2008, value: 1.04, source: "Forbes / Ross 2008-09 acquisition implied $1.1B" },
      { year: 2009, value: 1.01, source: "Forbes" },
      { year: 2010, value: 1.01, source: "Forbes" },
      { year: 2011, value: 1.02, source: "Forbes" },
      { year: 2012, value: 1.07, source: "Forbes" },
      { year: 2013, value: 1.14, source: "Forbes" },
      { year: 2014, value: 1.30, source: "Forbes" },
      { year: 2015, value: 2.10, source: "Forbes" },
      { year: 2016, value: 2.38, source: "Forbes" },
      { year: 2017, value: 2.58, source: "Forbes" },
      { year: 2018, value: 2.58, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Dolphins capture equal NFL national TV share (~$340M/yr) plus tier-2 international rights via Madrid/London games; Stephen Ross has been a vocal architect of NFL international expansion strategy.",
      stadium: "Hard Rock Stadium (1987, renovated 2016) is fully owned by the Dolphins and has been transformed into a multi-sport mega-venue hosting Miami Open tennis (Ross owns) and F1 Miami Grand Prix — non-NFL revenue is a structural advantage.",
      brand: "South Florida glamour brand with 1972 perfect season legacy; international fanbase strong in Latin America given Miami's gateway status.",
      marketSize: "Miami DMA #16 with strong corporate/luxury base; market shared with NBA Heat and MLB Marlins but Dolphins remain the dominant brand.",
      onField: "Tua Tagovailoa $212M extension and McDaniel offense produced 2022-2023 playoff appearances; defensive injuries and concussion concerns are the central roster risk."
    }
  },

  "New England Patriots": {
    extendedValuationHistory: [
      { year: 1998, value: 0.460, source: "Forbes" },
      { year: 1999, value: 0.525, source: "Forbes" },
      { year: 2000, value: 0.464, source: "Forbes" },
      { year: 2001, value: 0.571, source: "Forbes" },
      { year: 2002, value: 0.756, source: "Forbes / Gillette Stadium opened" },
      { year: 2003, value: 0.861, source: "Forbes" },
      { year: 2004, value: 1.04, source: "Forbes" },
      { year: 2005, value: 1.18, source: "Forbes" },
      { year: 2006, value: 1.04, source: "Forbes" },
      { year: 2007, value: 1.20, source: "Forbes" },
      { year: 2008, value: 1.32, source: "Forbes" },
      { year: 2009, value: 1.36, source: "Forbes" },
      { year: 2010, value: 1.37, source: "Forbes" },
      { year: 2011, value: 1.40, source: "Forbes" },
      { year: 2012, value: 1.64, source: "Forbes" },
      { year: 2013, value: 1.80, source: "Forbes" },
      { year: 2014, value: 2.60, source: "Forbes" },
      { year: 2015, value: 3.20, source: "Forbes" },
      { year: 2016, value: 3.40, source: "Forbes" },
      { year: 2017, value: 3.70, source: "Forbes" },
      { year: 2018, value: 3.80, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Patriots receive equal national share (~$340M/yr) but capture outsize primetime allocation and international fanbase value from the Belichick-Brady dynasty era's compounded brand equity.",
      stadium: "Gillette Stadium (2002) is privately owned by the Kraft family — built without public subsidy at $325M and now anchors Patriot Place mixed-use development, making it one of the highest non-NFL revenue venues in the league.",
      brand: "Six Super Bowl titles drove top-tier global NFL brand status; post-Brady transition has tested the brand but Kraft's sustained investment maintains premium positioning.",
      marketSize: "New England DMA #10 (Boston) functions as a 6-state regional monopoly — no other NFL franchise within hundreds of miles, generating exclusive corporate and merchandise capture.",
      onField: "Maye/Mayo era marks deliberate rebuild after dynasty wind-down; on-field weakness is the only valuation drag against an otherwise top-tier asset profile."
    }
  },

  "New York Jets": {
    extendedValuationHistory: [
      { year: 1998, value: 0.293, source: "Forbes" },
      { year: 1999, value: 0.450, source: "Forbes" },
      { year: 2000, value: 0.475, source: "Forbes / Hess sale process" },
      { year: 2001, value: 0.572, source: "Forbes / Woody Johnson $635M acquisition implied" },
      { year: 2002, value: 0.572, source: "Forbes" },
      { year: 2003, value: 0.635, source: "Forbes" },
      { year: 2004, value: 0.717, source: "Forbes" },
      { year: 2005, value: 0.760, source: "Forbes" },
      { year: 2006, value: 0.876, source: "Forbes" },
      { year: 2007, value: 1.17, source: "Forbes" },
      { year: 2008, value: 1.17, source: "Forbes" },
      { year: 2009, value: 1.14, source: "Forbes" },
      { year: 2010, value: 1.17, source: "Forbes" },
      { year: 2011, value: 1.22, source: "Forbes / MetLife Stadium opened 2010" },
      { year: 2012, value: 1.28, source: "Forbes" },
      { year: 2013, value: 1.38, source: "Forbes" },
      { year: 2014, value: 1.64, source: "Forbes" },
      { year: 2015, value: 2.10, source: "Forbes" },
      { year: 2016, value: 2.60, source: "Forbes" },
      { year: 2017, value: 2.75, source: "Forbes" },
      { year: 2018, value: 2.85, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Jets capture equal national share (~$340M/yr) and benefit from NY market primetime allocation despite extended on-field underperformance — a structural floor protected by league economics.",
      stadium: "MetLife Stadium (2010) jointly owned 50/50 with Giants — privately financed at $1.6B with no public subsidy; lacks clear naming rights revenue capture and concert/event income split with co-tenant limits Jets-specific upside.",
      brand: "Historic 1969 Super Bowl III legacy and Aaron Rodgers signing drove brand attention; tabloid market dynamics give the franchise outsize cultural footprint relative to recent results.",
      marketSize: "Largest US DMA #1 (NY metro) shared with Giants — the NY share split is the central valuation overhang versus single-tenant peers.",
      onField: "Rodgers-led 2024 disaster (3-14) followed by 2025 reset under new GM/HC; Garrett Wilson and rookie QB development are the central talent thesis."
    }
  },

  "Baltimore Ravens": {
    extendedValuationHistory: [
      { year: 1998, value: 0.291, source: "Forbes" },
      { year: 1999, value: 0.426, source: "Forbes" },
      { year: 2000, value: 0.502, source: "Forbes / SB XXXV champions" },
      { year: 2001, value: 0.620, source: "Forbes" },
      { year: 2002, value: 0.712, source: "Forbes" },
      { year: 2003, value: 0.776, source: "Forbes" },
      { year: 2004, value: 0.733, source: "Forbes / Bisciotti acquisition for $600M" },
      { year: 2005, value: 0.776, source: "Forbes" },
      { year: 2006, value: 0.848, source: "Forbes" },
      { year: 2007, value: 0.911, source: "Forbes" },
      { year: 2008, value: 1.06, source: "Forbes" },
      { year: 2009, value: 1.07, source: "Forbes" },
      { year: 2010, value: 1.07, source: "Forbes" },
      { year: 2011, value: 1.07, source: "Forbes" },
      { year: 2012, value: 1.09, source: "Forbes" },
      { year: 2013, value: 1.23, source: "Forbes / SB XLVII champions" },
      { year: 2014, value: 1.50, source: "Forbes" },
      { year: 2015, value: 2.00, source: "Forbes" },
      { year: 2016, value: 2.50, source: "Forbes" },
      { year: 2017, value: 2.59, source: "Forbes" },
      { year: 2018, value: 2.59, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Ravens receive equal national share (~$340M/yr) and benefit from primetime allocation as a perennial playoff contender; Lamar Jackson era has elevated national broadcast slots.",
      stadium: "M&T Bank Stadium (1998) is publicly owned by Maryland Stadium Authority; long-term lease and shared subsidy structure limits franchise-controlled venue revenue versus privately owned peers.",
      brand: "Two Super Bowl titles (2000, 2012) and the Ray Lewis-era defensive identity built durable national brand recognition; expansion-era 1996 origin makes it one of the NFL's youngest franchises.",
      marketSize: "Baltimore DMA #29 — mid-market with strong corporate base and regional reach into DC suburbs; competition with Commanders for Mid-Atlantic mindshare is muted by Ravens' on-field success.",
      onField: "Lamar Jackson 2x MVP and $260M extension anchor a contender window; offensive line investment and Derrick Henry signing in 2024 positioned franchise for deep playoff runs."
    }
  },

  "Cincinnati Bengals": {
    extendedValuationHistory: [
      { year: 1998, value: 0.253, source: "Forbes" },
      { year: 1999, value: 0.394, source: "Forbes" },
      { year: 2000, value: 0.421, source: "Forbes / Paul Brown Stadium opened" },
      { year: 2001, value: 0.504, source: "Forbes" },
      { year: 2002, value: 0.562, source: "Forbes" },
      { year: 2003, value: 0.619, source: "Forbes" },
      { year: 2004, value: 0.700, source: "Forbes" },
      { year: 2005, value: 0.747, source: "Forbes" },
      { year: 2006, value: 0.825, source: "Forbes" },
      { year: 2007, value: 0.876, source: "Forbes" },
      { year: 2008, value: 0.941, source: "Forbes" },
      { year: 2009, value: 0.875, source: "Forbes" },
      { year: 2010, value: 0.875, source: "Forbes" },
      { year: 2011, value: 0.871, source: "Forbes" },
      { year: 2012, value: 0.924, source: "Forbes" },
      { year: 2013, value: 0.990, source: "Forbes" },
      { year: 2014, value: 1.25, source: "Forbes" },
      { year: 2015, value: 1.68, source: "Forbes" },
      { year: 2016, value: 1.80, source: "Forbes" },
      { year: 2017, value: 1.80, source: "Forbes" },
      { year: 2018, value: 1.80, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Bengals receive equal national share (~$340M/yr); Burrow-era resurgence has dramatically improved primetime allocation and national relevance after a long stretch of off-Broadway scheduling.",
      stadium: "Paycor Stadium (2000, formerly Paul Brown Stadium) is publicly owned by Hamilton County — the lease was historically among the worst in the NFL for taxpayers and structurally limits franchise-captured non-game revenue.",
      brand: "Brown family ownership since 1968 represents one of the league's last family-operated franchises; Burrow/Chase/Higgins core has built a national young-fan brand premium.",
      marketSize: "Cincinnati DMA #36 — small market reliant on regional reach into Kentucky and Indiana; Bengals operate in lockstep with regional Reds (MLB) brand positioning.",
      onField: "Joe Burrow's $275M extension is the cap-defining anchor; Ja'Marr Chase and Tee Higgins extensions made Cincinnati the highest-paid skill-position group in the league."
    }
  },

  "Cleveland Browns": {
    extendedValuationHistory: [
      { year: 1999, value: 0.530, source: "Forbes / expansion franchise reborn" },
      { year: 2000, value: 0.464, source: "Forbes" },
      { year: 2001, value: 0.504, source: "Forbes" },
      { year: 2002, value: 0.583, source: "Forbes" },
      { year: 2003, value: 0.625, source: "Forbes" },
      { year: 2004, value: 0.733, source: "Forbes" },
      { year: 2005, value: 0.773, source: "Forbes" },
      { year: 2006, value: 0.852, source: "Forbes" },
      { year: 2007, value: 0.919, source: "Forbes" },
      { year: 2008, value: 1.04, source: "Forbes" },
      { year: 2009, value: 1.02, source: "Forbes" },
      { year: 2010, value: 1.02, source: "Forbes" },
      { year: 2011, value: 0.977, source: "Forbes" },
      { year: 2012, value: 1.00, source: "Forbes / Haslam acquisition for $1.05B" },
      { year: 2013, value: 1.01, source: "Forbes" },
      { year: 2014, value: 1.12, source: "Forbes" },
      { year: 2015, value: 1.50, source: "Forbes" },
      { year: 2016, value: 1.85, source: "Forbes" },
      { year: 2017, value: 1.95, source: "Forbes" },
      { year: 2018, value: 1.95, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Browns receive equal national share (~$340M/yr); Watson trade and persistent QB struggles have suppressed primetime slotting versus other AFC peers.",
      stadium: "Huntington Bank Field (1999, formerly FirstEnergy/Cleveland Browns Stadium) is publicly owned by Cleveland; new domed stadium in Brook Park planned with $600M public funding being negotiated.",
      brand: "Historic Paul Brown / Jim Brown legacy and intense regional 'Dawg Pound' fanbase preserved through 1996-1999 relocation hiatus; pre-merger championships (1950, 1954, 1955, 1964) remain NFL pedigree.",
      marketSize: "Cleveland DMA #19 — strong NE Ohio corporate base with Cavaliers (NBA) and Guardians (MLB) as in-market peers; regional brand reach into PA/WV.",
      onField: "Deshaun Watson's $230M fully guaranteed contract is widely viewed as the most damaging contract in modern NFL history, capping flexibility through 2026 — central valuation drag."
    }
  },

  "Pittsburgh Steelers": {
    extendedValuationHistory: [
      { year: 1998, value: 0.292, source: "Forbes" },
      { year: 1999, value: 0.391, source: "Forbes" },
      { year: 2000, value: 0.421, source: "Forbes" },
      { year: 2001, value: 0.524, source: "Forbes / Heinz Field opened" },
      { year: 2002, value: 0.608, source: "Forbes" },
      { year: 2003, value: 0.683, source: "Forbes" },
      { year: 2004, value: 0.776, source: "Forbes" },
      { year: 2005, value: 0.859, source: "Forbes / SB XL champions" },
      { year: 2006, value: 0.929, source: "Forbes" },
      { year: 2007, value: 0.994, source: "Forbes" },
      { year: 2008, value: 1.02, source: "Forbes / SB XLIII champions" },
      { year: 2009, value: 1.02, source: "Forbes" },
      { year: 2010, value: 1.02, source: "Forbes" },
      { year: 2011, value: 1.08, source: "Forbes" },
      { year: 2012, value: 1.12, source: "Forbes" },
      { year: 2013, value: 1.12, source: "Forbes" },
      { year: 2014, value: 1.35, source: "Forbes" },
      { year: 2015, value: 1.90, source: "Forbes" },
      { year: 2016, value: 2.25, source: "Forbes" },
      { year: 2017, value: 2.45, source: "Forbes" },
      { year: 2018, value: 2.59, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Steelers receive equal national share (~$340M/yr) plus outsized primetime slotting given national fanbase and 6 Super Bowl trophies — among the most-watched franchises by metropolitan TV ratings.",
      stadium: "Acrisure Stadium (2001, formerly Heinz Field) is publicly owned with shared subsidy; $260M renovation completed 2024 with Acrisure naming deal at ~$15M/year.",
      brand: "Rooney family ownership since 1933 — the NFL's most stable family-controlled franchise; 6 Super Bowl titles (most tied with Patriots) and Steel Curtain heritage drive top-3 NFL merchandise sales nationally.",
      marketSize: "Pittsburgh DMA #25 with deep blue-collar heritage; 'Steelers Nation' diaspora fanbase across PA/OH/WV gives outsize national merchandise footprint relative to home market.",
      onField: "Mike Tomlin's never-losing-season streak ended in 2024; Russell Wilson/Justin Fields-era reset with 2025 QB room rebuild marks the post-Big-Ben transition's continued search for franchise QB stability."
    }
  },

  "Houston Texans": {
    extendedValuationHistory: [
      { year: 2002, value: 0.700, source: "Forbes / inaugural season" },
      { year: 2003, value: 0.791, source: "Forbes" },
      { year: 2004, value: 0.905, source: "Forbes" },
      { year: 2005, value: 0.946, source: "Forbes" },
      { year: 2006, value: 1.04, source: "Forbes" },
      { year: 2007, value: 1.06, source: "Forbes" },
      { year: 2008, value: 1.17, source: "Forbes" },
      { year: 2009, value: 1.04, source: "Forbes" },
      { year: 2010, value: 1.04, source: "Forbes" },
      { year: 2011, value: 1.05, source: "Forbes" },
      { year: 2012, value: 1.15, source: "Forbes" },
      { year: 2013, value: 1.31, source: "Forbes" },
      { year: 2014, value: 1.45, source: "Forbes" },
      { year: 2015, value: 1.85, source: "Forbes" },
      { year: 2016, value: 2.50, source: "Forbes" },
      { year: 2017, value: 2.80, source: "Forbes" },
      { year: 2018, value: 2.80, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Texans receive equal national share (~$340M/yr); CJ Stroud-era resurgence has driven primetime slot allocation and dramatically improved Sunday Night Football appearances.",
      stadium: "NRG Stadium (2002) is publicly owned by Harris County Sports Authority; first NFL stadium with retractable roof; lease and naming rights split with stadium authority limits team-captured premium revenue.",
      brand: "Expansion 2002 franchise lacks deep heritage; Stroud/Anderson/Mixon young core has built modern entertainment-driven brand quickly; international fanbase via Mexico games strong.",
      marketSize: "Houston DMA #8 — top-10 market with energy industry corporate base, exclusive NFL franchise (no Texas A or sharing with Dallas market), strong demographic growth.",
      onField: "CJ Stroud's rookie-year MVP-caliber performance and DeMeco Ryans hire created a contender window; Stroud's eventual mega-extension is the central future cap question."
    }
  },

  "Indianapolis Colts": {
    extendedValuationHistory: [
      { year: 1998, value: 0.305, source: "Forbes" },
      { year: 1999, value: 0.370, source: "Forbes" },
      { year: 2000, value: 0.419, source: "Forbes" },
      { year: 2001, value: 0.502, source: "Forbes" },
      { year: 2002, value: 0.547, source: "Forbes" },
      { year: 2003, value: 0.589, source: "Forbes" },
      { year: 2004, value: 0.683, source: "Forbes" },
      { year: 2005, value: 0.715, source: "Forbes" },
      { year: 2006, value: 0.882, source: "Forbes / SB XLI champions" },
      { year: 2007, value: 1.00, source: "Forbes" },
      { year: 2008, value: 1.08, source: "Forbes / Lucas Oil Stadium opened" },
      { year: 2009, value: 1.07, source: "Forbes" },
      { year: 2010, value: 1.07, source: "Forbes" },
      { year: 2011, value: 1.06, source: "Forbes" },
      { year: 2012, value: 1.20, source: "Forbes" },
      { year: 2013, value: 1.28, source: "Forbes" },
      { year: 2014, value: 1.40, source: "Forbes" },
      { year: 2015, value: 1.88, source: "Forbes" },
      { year: 2016, value: 2.18, source: "Forbes" },
      { year: 2017, value: 2.38, source: "Forbes" },
      { year: 2018, value: 2.38, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Colts receive equal national share (~$340M/yr); Manning-era national footprint sustained durable primetime allocation that has continued through Andrew Luck retirement and post-Luck QB churn.",
      stadium: "Lucas Oil Stadium (2008) is publicly owned by Indiana Stadium and Convention Building Authority; retractable roof drives non-NFL events including Final Fours, Big Ten Championship.",
      brand: "Irsay family ownership since 1972; Peyton Manning era built durable national brand; Lucas Oil naming rights deal among the league's highest profile.",
      marketSize: "Indianapolis DMA #25 — small/mid market without competing NFL brands across Indiana; Colts function as the state's pro football identity.",
      onField: "Anthony Richardson development, Joe Flacco bridge, and DC Lou Anarumo defensive rebuild are the central post-Manning roster questions; running game led by Jonathan Taylor."
    }
  },

  "Jacksonville Jaguars": {
    extendedValuationHistory: [
      { year: 1998, value: 0.294, source: "Forbes" },
      { year: 1999, value: 0.419, source: "Forbes" },
      { year: 2000, value: 0.402, source: "Forbes" },
      { year: 2001, value: 0.474, source: "Forbes" },
      { year: 2002, value: 0.540, source: "Forbes" },
      { year: 2003, value: 0.580, source: "Forbes" },
      { year: 2004, value: 0.661, source: "Forbes" },
      { year: 2005, value: 0.732, source: "Forbes / SB XXXIX hosted" },
      { year: 2006, value: 0.785, source: "Forbes" },
      { year: 2007, value: 0.834, source: "Forbes" },
      { year: 2008, value: 0.876, source: "Forbes" },
      { year: 2009, value: 0.817, source: "Forbes" },
      { year: 2010, value: 0.770, source: "Forbes" },
      { year: 2011, value: 0.725, source: "Forbes / Khan acquisition for $760M" },
      { year: 2012, value: 0.770, source: "Forbes" },
      { year: 2013, value: 0.840, source: "Forbes" },
      { year: 2014, value: 0.965, source: "Forbes" },
      { year: 2015, value: 1.48, source: "Forbes" },
      { year: 2016, value: 2.08, source: "Forbes" },
      { year: 2017, value: 2.08, source: "Forbes" },
      { year: 2018, value: 2.08, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Jaguars receive equal national share (~$340M/yr) plus annual London game revenue and multi-year Wembley scheduling (now Wembley + Tottenham); international rights-share is the franchise's secondary media pillar.",
      stadium: "EverBank Stadium (1995) is publicly owned by Jacksonville; major $1.4B 'Stadium of the Future' renovation underway 2025-2028 with $625M city contribution.",
      brand: "Expansion 1995 franchise; Shad Khan / Fulham overlap and London game commitment positions Jaguars as the NFL's de facto international brand vehicle.",
      marketSize: "Jacksonville DMA #41 — smallest NFL market in the southeast; revenue floor sustained by London games and equal-share TV economics.",
      onField: "Trevor Lawrence's $275M extension and Liam Coen offensive system mark the post-Doug Pederson rebuild; AFC South pendulum shifts have created repeated opening windows."
    }
  },

  "Tennessee Titans": {
    extendedValuationHistory: [
      { year: 1998, value: 0.296, source: "Forbes / Houston Oilers final season" },
      { year: 1999, value: 0.502, source: "Forbes / SB XXXIV runner-up; Nashville stadium opened" },
      { year: 2000, value: 0.559, source: "Forbes" },
      { year: 2001, value: 0.607, source: "Forbes" },
      { year: 2002, value: 0.663, source: "Forbes" },
      { year: 2003, value: 0.736, source: "Forbes" },
      { year: 2004, value: 0.803, source: "Forbes" },
      { year: 2005, value: 0.838, source: "Forbes" },
      { year: 2006, value: 0.916, source: "Forbes" },
      { year: 2007, value: 0.994, source: "Forbes" },
      { year: 2008, value: 1.04, source: "Forbes" },
      { year: 2009, value: 0.965, source: "Forbes" },
      { year: 2010, value: 0.972, source: "Forbes" },
      { year: 2011, value: 0.998, source: "Forbes" },
      { year: 2012, value: 1.05, source: "Forbes" },
      { year: 2013, value: 1.06, source: "Forbes" },
      { year: 2014, value: 1.16, source: "Forbes" },
      { year: 2015, value: 1.58, source: "Forbes" },
      { year: 2016, value: 1.88, source: "Forbes" },
      { year: 2017, value: 2.05, source: "Forbes" },
      { year: 2018, value: 2.20, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Titans receive equal national share (~$340M/yr); Derrick Henry-era physicality drove primetime slotting that has receded post-Henry trade.",
      stadium: "Nissan Stadium (1999) being replaced by new $2.1B enclosed stadium opening 2027 with $1.26B public funding — among the largest public subsidies in NFL history; Adams family ownership.",
      brand: "Houston Oilers heritage transferred to Nashville 1997-99; Music City branding integrates with Nashville's tourism economy.",
      marketSize: "Nashville DMA #29 — fastest-growing major US market with Predators (NHL) as in-market peer; corporate growth tied to relocation boom.",
      onField: "Will Levis development and post-Henry rebuild; defensive talent (Jeffery Simmons) anchors but consistent QB and offensive line are the central need."
    }
  },

  "Denver Broncos": {
    extendedValuationHistory: [
      { year: 1998, value: 0.358, source: "Forbes / SB XXXII champions" },
      { year: 1999, value: 0.499, source: "Forbes / SB XXXIII champions" },
      { year: 2000, value: 0.604, source: "Forbes" },
      { year: 2001, value: 0.683, source: "Forbes / Invesco Field opened" },
      { year: 2002, value: 0.769, source: "Forbes" },
      { year: 2003, value: 0.815, source: "Forbes" },
      { year: 2004, value: 0.890, source: "Forbes" },
      { year: 2005, value: 0.984, source: "Forbes" },
      { year: 2006, value: 1.06, source: "Forbes" },
      { year: 2007, value: 1.06, source: "Forbes" },
      { year: 2008, value: 1.06, source: "Forbes" },
      { year: 2009, value: 1.05, source: "Forbes" },
      { year: 2010, value: 1.05, source: "Forbes" },
      { year: 2011, value: 1.05, source: "Forbes" },
      { year: 2012, value: 1.16, source: "Forbes" },
      { year: 2013, value: 1.16, source: "Forbes" },
      { year: 2014, value: 1.45, source: "Forbes" },
      { year: 2015, value: 1.94, source: "Forbes / SB 50 champions" },
      { year: 2016, value: 2.40, source: "Forbes" },
      { year: 2017, value: 2.60, source: "Forbes" },
      { year: 2018, value: 2.65, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Broncos receive equal national share (~$340M/yr); 3 Super Bowl titles and Manning/Elway legacy sustain primetime slotting and national merchandise sales above DMA-implied baseline.",
      stadium: "Empower Field at Mile High (2001) is publicly owned by Metropolitan Football Stadium District; Empower naming rights $36M/year deal among the league's strongest.",
      brand: "John Elway and Peyton Manning quarterbacks built durable Mountain West regional brand; 3 SB titles (1997, 1998, 2015) anchor heritage; Walton-Penner ownership group ($4.65B 2022 acquisition — record at time) brings deep capital.",
      marketSize: "Denver DMA #16 — large Mountain West regional capture spanning Wyoming/Montana/New Mexico; Walmart heir Rob Walton's net worth provides among the deepest financial backstops in the league.",
      onField: "Bo Nix-led 2024 playoff appearance and Sean Payton offensive system established post-Wilson reset; defensive rebuild led by Patrick Surtain II."
    }
  },

  "Kansas City Chiefs": {
    extendedValuationHistory: [
      { year: 1998, value: 0.353, source: "Forbes" },
      { year: 1999, value: 0.401, source: "Forbes" },
      { year: 2000, value: 0.418, source: "Forbes" },
      { year: 2001, value: 0.490, source: "Forbes" },
      { year: 2002, value: 0.591, source: "Forbes" },
      { year: 2003, value: 0.614, source: "Forbes" },
      { year: 2004, value: 0.686, source: "Forbes" },
      { year: 2005, value: 0.751, source: "Forbes" },
      { year: 2006, value: 0.847, source: "Forbes" },
      { year: 2007, value: 0.960, source: "Forbes" },
      { year: 2008, value: 1.02, source: "Forbes" },
      { year: 2009, value: 0.965, source: "Forbes" },
      { year: 2010, value: 0.965, source: "Forbes / Arrowhead renovation" },
      { year: 2011, value: 0.955, source: "Forbes" },
      { year: 2012, value: 1.01, source: "Forbes" },
      { year: 2013, value: 1.01, source: "Forbes" },
      { year: 2014, value: 1.13, source: "Forbes" },
      { year: 2015, value: 1.50, source: "Forbes" },
      { year: 2016, value: 1.98, source: "Forbes" },
      { year: 2017, value: 2.10, source: "Forbes" },
      { year: 2018, value: 2.10, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Chiefs receive equal national share (~$340M/yr) plus the league's most valuable primetime allocation since 2018 — Mahomes-era ratings premium drives top-tier exposure across all 4 broadcast partners.",
      stadium: "GEHA Field at Arrowhead (1972) is publicly owned by Jackson County; lease through 2031; new stadium discussions ongoing — Hunt family weighing Missouri-Kansas competing offers.",
      brand: "Hunt family ownership since 1960 (founding AFL); 3 recent Super Bowl titles (2019, 2022, 2023) and Mahomes-Kelce-Reid trifecta drove modern national brand reset; Taylor Swift adjacency added cross-cultural reach.",
      marketSize: "Kansas City DMA #34 — small market; Royals (MLB) only in-market peer; Mahomes era has decoupled Chiefs valuation from market-size limits.",
      onField: "Patrick Mahomes' 10yr/$450M deal (signed 2020) is the cap-defining cornerstone; Travis Kelce, Chris Jones extensions sustain dynasty window through ~2027."
    }
  },

  "Las Vegas Raiders": {
    extendedValuationHistory: [
      { year: 1998, value: 0.276, source: "Forbes / Oakland" },
      { year: 1999, value: 0.350, source: "Forbes / Oakland" },
      { year: 2000, value: 0.396, source: "Forbes / Oakland" },
      { year: 2001, value: 0.458, source: "Forbes" },
      { year: 2002, value: 0.539, source: "Forbes / SB XXXVII runner-up" },
      { year: 2003, value: 0.617, source: "Forbes" },
      { year: 2004, value: 0.690, source: "Forbes" },
      { year: 2005, value: 0.736, source: "Forbes" },
      { year: 2006, value: 0.785, source: "Forbes" },
      { year: 2007, value: 0.812, source: "Forbes" },
      { year: 2008, value: 0.861, source: "Forbes" },
      { year: 2009, value: 0.797, source: "Forbes" },
      { year: 2010, value: 0.758, source: "Forbes" },
      { year: 2011, value: 0.761, source: "Forbes" },
      { year: 2012, value: 0.785, source: "Forbes" },
      { year: 2013, value: 0.825, source: "Forbes" },
      { year: 2014, value: 0.970, source: "Forbes" },
      { year: 2015, value: 1.43, source: "Forbes" },
      { year: 2016, value: 2.10, source: "Forbes / Vegas relocation announced" },
      { year: 2017, value: 2.38, source: "Forbes" },
      { year: 2018, value: 2.42, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Raiders receive equal national share (~$340M/yr); Vegas relocation 2020 created national entertainment-economy cross-marketing premium especially with Super Bowl 58 Las Vegas hosting.",
      stadium: "Allegiant Stadium (2020) — $1.9B build with $750M Nevada room-tax public subsidy; Allegiant naming rights $20-25M/year; venue hosts SB 58, Vegas Bowl, NCAA Final Four 2028.",
      brand: "Davis family ownership since founding (Al Davis 1972, Mark Davis 2011); Silver and Black brand among NFL's most internationally recognized; Vegas brand pivot expanded entertainment-tourism crossover.",
      marketSize: "Vegas DMA #40 — small DMA but exclusive franchise with 40M+ annual tourists driving outsize ticket pricing power and event economics; corporate suite revenue among league's top tier.",
      onField: "Maxx Crosby/Geno Smith era follow successive coaching/QB instability; central asset thesis is venue economics, not on-field strength."
    }
  },

  "Los Angeles Chargers": {
    extendedValuationHistory: [
      { year: 1998, value: 0.244, source: "Forbes / San Diego" },
      { year: 1999, value: 0.378, source: "Forbes / San Diego" },
      { year: 2000, value: 0.337, source: "Forbes / San Diego" },
      { year: 2001, value: 0.405, source: "Forbes" },
      { year: 2002, value: 0.464, source: "Forbes" },
      { year: 2003, value: 0.521, source: "Forbes" },
      { year: 2004, value: 0.621, source: "Forbes" },
      { year: 2005, value: 0.683, source: "Forbes" },
      { year: 2006, value: 0.797, source: "Forbes" },
      { year: 2007, value: 0.836, source: "Forbes" },
      { year: 2008, value: 0.888, source: "Forbes" },
      { year: 2009, value: 0.844, source: "Forbes" },
      { year: 2010, value: 0.825, source: "Forbes" },
      { year: 2011, value: 0.831, source: "Forbes" },
      { year: 2012, value: 0.901, source: "Forbes" },
      { year: 2013, value: 0.949, source: "Forbes" },
      { year: 2014, value: 1.07, source: "Forbes" },
      { year: 2015, value: 1.53, source: "Forbes" },
      { year: 2016, value: 2.08, source: "Forbes / LA relocation announced" },
      { year: 2017, value: 2.28, source: "Forbes" },
      { year: 2018, value: 2.28, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Chargers receive equal national share (~$340M/yr); LA market presence and Justin Herbert primetime appeal generate competitive but secondary exposure to Rams as co-tenant.",
      stadium: "SoFi Stadium (2020) — Chargers are tenant of Rams owner Stan Kroenke's $5.5B venue; 30-year lease at favorable terms but no equity in stadium real estate or naming rights.",
      brand: "Spanos family ownership since 1984 ($70M Gene Klein purchase); 2017 LA relocation rebuilt brand from San Diego origins; underdog brand positioning vs. Rams in shared market.",
      marketSize: "Los Angeles DMA #2 — second-largest US market shared with Rams; Chargers capture secondary corporate and merchandise share in dual-tenant economics.",
      onField: "Justin Herbert as franchise QB with $260M extension; Jim Harbaugh hire 2024 transformed culture; AFC West gauntlet vs. Chiefs/Broncos/Raiders constrains playoff path."
    }
  },

  "Dallas Cowboys": {
    extendedValuationHistory: [
      { year: 1998, value: 0.413, source: "Forbes" },
      { year: 1999, value: 0.663, source: "Forbes" },
      { year: 2000, value: 0.743, source: "Forbes" },
      { year: 2001, value: 0.784, source: "Forbes" },
      { year: 2002, value: 0.851, source: "Forbes" },
      { year: 2003, value: 0.923, source: "Forbes" },
      { year: 2004, value: 1.06, source: "Forbes" },
      { year: 2005, value: 1.17, source: "Forbes" },
      { year: 2006, value: 1.17, source: "Forbes" },
      { year: 2007, value: 1.50, source: "Forbes" },
      { year: 2008, value: 1.61, source: "Forbes" },
      { year: 2009, value: 1.65, source: "Forbes / AT&T Stadium opened" },
      { year: 2010, value: 1.81, source: "Forbes" },
      { year: 2011, value: 1.85, source: "Forbes" },
      { year: 2012, value: 2.10, source: "Forbes" },
      { year: 2013, value: 2.30, source: "Forbes" },
      { year: 2014, value: 3.20, source: "Forbes" },
      { year: 2015, value: 4.00, source: "Forbes" },
      { year: 2016, value: 4.20, source: "Forbes" },
      { year: 2017, value: 4.80, source: "Forbes" },
      { year: 2018, value: 5.00, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Cowboys receive equal national share (~$340M/yr) but capture by far the highest primetime allocation in the NFL — 'America's Team' branding drives ratings premium across CBS/FOX/NBC/ESPN/Amazon partners.",
      stadium: "AT&T Stadium (2009) — $1.3B Jerry Jones-financed venue with $325M public subsidy; AT&T naming rights ~$17-19M/year; non-NFL events (concerts, college football, boxing) generate among the highest non-game venue revenue in pro sports.",
      brand: "Jerry Jones ownership since 1989 ($140M for franchise + stadium); 5 Super Bowl titles (most recent 1995); the NFL's #1 merchandise franchise globally; Cowboys star is the most recognizable team logo in American sports.",
      marketSize: "Dallas-Fort Worth DMA #5 — fast-growing market with deep corporate base; Texas exclusivity (no shared market) and 'America's Team' branding extend reach far beyond DMA borders.",
      onField: "Dak Prescott $240M extension; CeeDee Lamb / Micah Parsons extensions sustained core; consistent regular-season strength has not produced playoff breakthroughs since 1995."
    }
  },

  "New York Giants": {
    extendedValuationHistory: [
      { year: 1998, value: 0.288, source: "Forbes" },
      { year: 1999, value: 0.379, source: "Forbes" },
      { year: 2000, value: 0.412, source: "Forbes" },
      { year: 2001, value: 0.487, source: "Forbes" },
      { year: 2002, value: 0.573, source: "Forbes" },
      { year: 2003, value: 0.637, source: "Forbes" },
      { year: 2004, value: 0.755, source: "Forbes" },
      { year: 2005, value: 0.806, source: "Forbes" },
      { year: 2006, value: 0.889, source: "Forbes" },
      { year: 2007, value: 0.974, source: "Forbes / SB XLII champions" },
      { year: 2008, value: 1.18, source: "Forbes" },
      { year: 2009, value: 1.18, source: "Forbes" },
      { year: 2010, value: 1.18, source: "Forbes" },
      { year: 2011, value: 1.30, source: "Forbes / SB XLVI champions" },
      { year: 2012, value: 1.47, source: "Forbes" },
      { year: 2013, value: 1.55, source: "Forbes" },
      { year: 2014, value: 1.95, source: "Forbes" },
      { year: 2015, value: 2.80, source: "Forbes" },
      { year: 2016, value: 3.10, source: "Forbes" },
      { year: 2017, value: 3.30, source: "Forbes" },
      { year: 2018, value: 3.30, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Giants receive equal national share (~$340M/yr) plus consistently high primetime allocation given NY market and 4 Super Bowl titles; Mara/Tisch family ownership preserves traditional broadcast prestige.",
      stadium: "MetLife Stadium (2010) jointly owned 50/50 with Jets — $1.6B privately financed; revenue split with co-tenant constrains total Giants-controlled venue economics relative to single-tenant peers.",
      brand: "Mara family ownership since 1925 — among the NFL's oldest continuous franchises; 4 Super Bowls (1986, 1990, 2007, 2011); Tisch family co-owns since 1991.",
      marketSize: "NY metro DMA #1 — largest US market shared with Jets; Giants typically capture larger corporate and historical fan share than co-tenant.",
      onField: "Daniel Jones era ended 2024; rookie QB development, Brian Daboll/Joe Schoen tenure, and Saquon Barkley trade aftermath are the central reset questions."
    }
  },

  "Philadelphia Eagles": {
    extendedValuationHistory: [
      { year: 1998, value: 0.248, source: "Forbes" },
      { year: 1999, value: 0.378, source: "Forbes" },
      { year: 2000, value: 0.401, source: "Forbes" },
      { year: 2001, value: 0.490, source: "Forbes" },
      { year: 2002, value: 0.617, source: "Forbes" },
      { year: 2003, value: 0.683, source: "Forbes / Lincoln Financial Field opened" },
      { year: 2004, value: 0.733, source: "Forbes / SB XXXIX runner-up" },
      { year: 2005, value: 0.833, source: "Forbes" },
      { year: 2006, value: 0.952, source: "Forbes" },
      { year: 2007, value: 1.05, source: "Forbes" },
      { year: 2008, value: 1.12, source: "Forbes" },
      { year: 2009, value: 1.12, source: "Forbes" },
      { year: 2010, value: 1.12, source: "Forbes" },
      { year: 2011, value: 1.16, source: "Forbes" },
      { year: 2012, value: 1.26, source: "Forbes" },
      { year: 2013, value: 1.31, source: "Forbes" },
      { year: 2014, value: 1.47, source: "Forbes" },
      { year: 2015, value: 1.93, source: "Forbes" },
      { year: 2016, value: 2.40, source: "Forbes" },
      { year: 2017, value: 2.65, source: "Forbes / SB LII champions" },
      { year: 2018, value: 2.75, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Eagles receive equal national share (~$340M/yr); recent Super Bowl appearances (2017 win, 2022 runner-up, 2024 win) sustain top-tier primetime allocation.",
      stadium: "Lincoln Financial Field (2003) is publicly owned by Philadelphia Authority for Industrial Development; Lincoln Financial naming rights ~$6-7M/year; Lurie-driven renovations and concert revenue.",
      brand: "Jeffrey Lurie ownership since 1994 ($185M); 2 Super Bowl titles (2017, 2024); among the NFL's most passionate fanbases with high merchandise sales relative to market size.",
      marketSize: "Philadelphia DMA #4 — top-5 market with deep corporate and pharma base; mid-Atlantic regional reach into NJ/DE/PA suburbs.",
      onField: "Jalen Hurts' $255M extension and Saquon Barkley free-agent signing produced 2024 Super Bowl title; Vic Fangio defense and Kellen Moore offense rebuilt championship architecture."
    }
  },

  "Washington Commanders": {
    extendedValuationHistory: [
      { year: 1998, value: 0.408, source: "Forbes / Redskins" },
      { year: 1999, value: 0.607, source: "Forbes / Snyder $800M acquisition" },
      { year: 2000, value: 0.741, source: "Forbes" },
      { year: 2001, value: 0.798, source: "Forbes" },
      { year: 2002, value: 0.845, source: "Forbes" },
      { year: 2003, value: 0.952, source: "Forbes" },
      { year: 2004, value: 1.10, source: "Forbes / NFL's 1st billion-dollar team" },
      { year: 2005, value: 1.26, source: "Forbes" },
      { year: 2006, value: 1.42, source: "Forbes" },
      { year: 2007, value: 1.47, source: "Forbes" },
      { year: 2008, value: 1.54, source: "Forbes" },
      { year: 2009, value: 1.55, source: "Forbes" },
      { year: 2010, value: 1.55, source: "Forbes" },
      { year: 2011, value: 1.56, source: "Forbes" },
      { year: 2012, value: 1.60, source: "Forbes" },
      { year: 2013, value: 1.70, source: "Forbes" },
      { year: 2014, value: 2.40, source: "Forbes" },
      { year: 2015, value: 2.85, source: "Forbes" },
      { year: 2016, value: 2.95, source: "Forbes" },
      { year: 2017, value: 3.10, source: "Forbes" },
      { year: 2018, value: 3.10, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Commanders receive equal national share (~$340M/yr); Josh Harris ownership and Jayden Daniels rookie excitement boosted primetime allocation after Snyder-era ratings depression.",
      stadium: "Northwest Stadium (1997, formerly FedExField) is privately owned by team; aging facility with deferred maintenance; new $3.6B stadium plans at RFK site (DC) being negotiated for 2030 opening.",
      brand: "Snyder-era brand damage (Washington Football Team rebrand 2020, Commanders rebrand 2022); Josh Harris-led ownership group ($6.05B 2023 acquisition — record at time) leads brand restoration.",
      marketSize: "Washington DC DMA #9 — top-10 market with federal government corporate base; competition with Ravens for Mid-Atlantic mindshare moderated by larger DMA.",
      onField: "Jayden Daniels rookie of the year 2024; Dan Quinn coaching tenure produced immediate playoff result; offensive line and secondary remain key roster priorities."
    }
  },

  "Chicago Bears": {
    extendedValuationHistory: [
      { year: 1998, value: 0.319, source: "Forbes" },
      { year: 1999, value: 0.420, source: "Forbes" },
      { year: 2000, value: 0.451, source: "Forbes" },
      { year: 2001, value: 0.538, source: "Forbes" },
      { year: 2002, value: 0.582, source: "Forbes" },
      { year: 2003, value: 0.683, source: "Forbes / Soldier Field renovation" },
      { year: 2004, value: 0.785, source: "Forbes" },
      { year: 2005, value: 0.889, source: "Forbes" },
      { year: 2006, value: 0.984, source: "Forbes / SB XLI runner-up" },
      { year: 2007, value: 1.06, source: "Forbes" },
      { year: 2008, value: 1.13, source: "Forbes" },
      { year: 2009, value: 1.11, source: "Forbes" },
      { year: 2010, value: 1.11, source: "Forbes" },
      { year: 2011, value: 1.07, source: "Forbes" },
      { year: 2012, value: 1.19, source: "Forbes" },
      { year: 2013, value: 1.25, source: "Forbes" },
      { year: 2014, value: 1.50, source: "Forbes" },
      { year: 2015, value: 2.45, source: "Forbes" },
      { year: 2016, value: 2.85, source: "Forbes" },
      { year: 2017, value: 2.85, source: "Forbes" },
      { year: 2018, value: 2.90, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Bears receive equal national share (~$340M/yr) plus historic primetime allocation given Chicago market and franchise legacy; Caleb Williams hype boosted national TV scheduling.",
      stadium: "Soldier Field (1924, renovated 2003) is publicly owned by Chicago Park District — smallest capacity stadium in the NFL; new $3.2B lakefront stadium proposal under public negotiation.",
      brand: "McCaskey/Halas family ownership — among NFL's founding franchises (1920); 9 NFL championships including 1985 SB title; Bears brand among the league's most internationally recognized.",
      marketSize: "Chicago DMA #3 — top-3 market with deep corporate base; Midwest regional reach across IL/IN/IA/WI; in-market shares with Cubs/White Sox/Bulls/Blackhawks.",
      onField: "Caleb Williams as franchise QB with rookie-contract value; Ben Johnson hire 2025 brought offensive system overhaul; defensive talent rebuilt under recent regime."
    }
  },

  "Detroit Lions": {
    extendedValuationHistory: [
      { year: 1998, value: 0.262, source: "Forbes" },
      { year: 1999, value: 0.328, source: "Forbes" },
      { year: 2000, value: 0.396, source: "Forbes" },
      { year: 2001, value: 0.477, source: "Forbes" },
      { year: 2002, value: 0.612, source: "Forbes / Ford Field opened" },
      { year: 2003, value: 0.683, source: "Forbes" },
      { year: 2004, value: 0.769, source: "Forbes" },
      { year: 2005, value: 0.839, source: "Forbes" },
      { year: 2006, value: 0.886, source: "Forbes" },
      { year: 2007, value: 0.917, source: "Forbes" },
      { year: 2008, value: 0.917, source: "Forbes" },
      { year: 2009, value: 0.844, source: "Forbes" },
      { year: 2010, value: 0.817, source: "Forbes" },
      { year: 2011, value: 0.855, source: "Forbes" },
      { year: 2012, value: 0.900, source: "Forbes" },
      { year: 2013, value: 0.960, source: "Forbes" },
      { year: 2014, value: 1.10, source: "Forbes" },
      { year: 2015, value: 1.44, source: "Forbes" },
      { year: 2016, value: 1.65, source: "Forbes" },
      { year: 2017, value: 1.70, source: "Forbes" },
      { year: 2018, value: 1.70, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Lions receive equal national share (~$340M/yr); Dan Campbell era reset has driven dramatic primetime increase including hosting Thanksgiving and 2024 NFC playoff slate.",
      stadium: "Ford Field (2002) is privately owned by Ford family; Ford naming integration with parent automaker provides corporate marketing synergy beyond pure naming-rights revenue.",
      brand: "Ford family ownership since 1963; among NFL's longest playoff droughts (1957 last championship) finally broken with 2023-24 NFC contender breakthrough.",
      marketSize: "Detroit DMA #14 — large but declining market; auto-industry economic concentration creates correlated economic risk.",
      onField: "Jared Goff's $212M extension and Dan Campbell coaching established contender identity; Aidan Hutchinson injury return is the central 2025 roster question."
    }
  },

  "Green Bay Packers": {
    extendedValuationHistory: [
      { year: 1998, value: 0.336, source: "Forbes" },
      { year: 1999, value: 0.403, source: "Forbes" },
      { year: 2000, value: 0.435, source: "Forbes" },
      { year: 2001, value: 0.515, source: "Forbes" },
      { year: 2002, value: 0.609, source: "Forbes" },
      { year: 2003, value: 0.694, source: "Forbes / Lambeau Field renovation" },
      { year: 2004, value: 0.756, source: "Forbes" },
      { year: 2005, value: 0.911, source: "Forbes" },
      { year: 2006, value: 1.00, source: "Forbes" },
      { year: 2007, value: 1.02, source: "Forbes" },
      { year: 2008, value: 1.02, source: "Forbes" },
      { year: 2009, value: 1.02, source: "Forbes" },
      { year: 2010, value: 1.02, source: "Forbes / SB XLV champions" },
      { year: 2011, value: 1.13, source: "Forbes" },
      { year: 2012, value: 1.19, source: "Forbes" },
      { year: 2013, value: 1.18, source: "Forbes" },
      { year: 2014, value: 1.38, source: "Forbes" },
      { year: 2015, value: 1.95, source: "Forbes" },
      { year: 2016, value: 2.35, source: "Forbes" },
      { year: 2017, value: 2.55, source: "Forbes" },
      { year: 2018, value: 2.63, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Packers receive equal national share (~$340M/yr); 13 NFL championships and Lambeau heritage drive sustained primetime allocation despite small DMA.",
      stadium: "Lambeau Field (1957) is publicly owned by Green Bay Stadium District — uniquely small-market venue with high stake-holding fan tradition; Titletown District mixed-use development extends non-game revenue.",
      brand: "Public-shareholder ownership since 1923 — only publicly owned major US pro sports franchise; 13 NFL championships (most all-time); Bart Starr/Brett Favre/Aaron Rodgers QB lineage.",
      marketSize: "Green Bay DMA #69 — by far the smallest NFL market; Wisconsin-wide and national 'shareholder' fanbase decouples valuation from DMA size.",
      onField: "Jordan Love $220M extension after Aaron Rodgers trade; Matt LaFleur offensive system and young receiving corps anchor post-Rodgers era."
    }
  },

  "Minnesota Vikings": {
    extendedValuationHistory: [
      { year: 1998, value: 0.334, source: "Forbes" },
      { year: 1999, value: 0.371, source: "Forbes" },
      { year: 2000, value: 0.394, source: "Forbes" },
      { year: 2001, value: 0.481, source: "Forbes" },
      { year: 2002, value: 0.523, source: "Forbes" },
      { year: 2003, value: 0.604, source: "Forbes" },
      { year: 2004, value: 0.658, source: "Forbes" },
      { year: 2005, value: 0.720, source: "Forbes / Wilf $600M acquisition" },
      { year: 2006, value: 0.782, source: "Forbes" },
      { year: 2007, value: 0.839, source: "Forbes" },
      { year: 2008, value: 0.839, source: "Forbes" },
      { year: 2009, value: 0.774, source: "Forbes" },
      { year: 2010, value: 0.774, source: "Forbes" },
      { year: 2011, value: 0.796, source: "Forbes" },
      { year: 2012, value: 0.975, source: "Forbes / U.S. Bank Stadium funding approved" },
      { year: 2013, value: 1.01, source: "Forbes" },
      { year: 2014, value: 1.16, source: "Forbes" },
      { year: 2015, value: 1.59, source: "Forbes" },
      { year: 2016, value: 2.20, source: "Forbes / U.S. Bank Stadium opened" },
      { year: 2017, value: 2.40, source: "Forbes" },
      { year: 2018, value: 2.40, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Vikings receive equal national share (~$340M/yr); Justin Jefferson era-driven primetime allocation gain; Kevin O'Connell offensive system raised national profile.",
      stadium: "U.S. Bank Stadium (2016) — $1.06B build with $498M public subsidy; among NFL's most architecturally distinctive venues; U.S. Bank naming rights $20-25M/year.",
      brand: "Wilf family ownership since 2005; rich playoff/Super Bowl runner-up history (4 SB appearances) without title; Jefferson-McCarthy-O'Connell rebuild defining new era.",
      marketSize: "Minneapolis-St. Paul DMA #15 — strong corporate base anchored by Target, Best Buy, 3M; Vikings function as state monopoly with regional reach into Dakotas/Iowa/Wisconsin.",
      onField: "JJ McCarthy as franchise QB after Kirk Cousins departure; Justin Jefferson's $140M extension is the league's largest non-QB deal; defensive rebuild under Brian Flores."
    }
  },

  "Atlanta Falcons": {
    extendedValuationHistory: [
      { year: 1998, value: 0.260, source: "Forbes / SB XXXIII runner-up" },
      { year: 1999, value: 0.357, source: "Forbes" },
      { year: 2000, value: 0.302, source: "Forbes" },
      { year: 2001, value: 0.407, source: "Forbes / Blank acquisition for $545M" },
      { year: 2002, value: 0.499, source: "Forbes" },
      { year: 2003, value: 0.567, source: "Forbes" },
      { year: 2004, value: 0.630, source: "Forbes" },
      { year: 2005, value: 0.739, source: "Forbes" },
      { year: 2006, value: 0.814, source: "Forbes" },
      { year: 2007, value: 0.872, source: "Forbes" },
      { year: 2008, value: 0.831, source: "Forbes" },
      { year: 2009, value: 0.814, source: "Forbes" },
      { year: 2010, value: 0.814, source: "Forbes" },
      { year: 2011, value: 0.831, source: "Forbes" },
      { year: 2012, value: 0.933, source: "Forbes" },
      { year: 2013, value: 1.13, source: "Forbes" },
      { year: 2014, value: 1.13, source: "Forbes" },
      { year: 2015, value: 1.67, source: "Forbes" },
      { year: 2016, value: 2.13, source: "Forbes / SB LI runner-up" },
      { year: 2017, value: 2.48, source: "Forbes / Mercedes-Benz Stadium opened" },
      { year: 2018, value: 2.60, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Falcons receive equal national share (~$340M/yr); Kirk Cousins signing 2024 boosted primetime allocation but on-field results have not sustained ratings premium.",
      stadium: "Mercedes-Benz Stadium (2017) is privately owned by Arthur Blank — $1.6B build; Mercedes naming rights $12M/year; ATL United (MLS) co-tenant; concert/non-NFL events generate among league's top non-game revenue.",
      brand: "Arthur Blank ownership since 2002 (Home Depot co-founder); 2 Super Bowl runner-up appearances (1998, 2016); strong Atlanta market integration with United (MLS) and PGA Tour Championship.",
      marketSize: "Atlanta DMA #6 — top-10 market with deep corporate base; Falcons compete with Hawks/Braves/United for fan share but capture top NFL economics.",
      onField: "Michael Penix Jr. drafted 2024 to inherit from Kirk Cousins; Bijan Robinson and Drake London anchor offensive talent; rebuilding defense under new staff."
    }
  },

  "Carolina Panthers": {
    extendedValuationHistory: [
      { year: 1998, value: 0.323, source: "Forbes" },
      { year: 1999, value: 0.402, source: "Forbes" },
      { year: 2000, value: 0.413, source: "Forbes" },
      { year: 2001, value: 0.462, source: "Forbes" },
      { year: 2002, value: 0.524, source: "Forbes" },
      { year: 2003, value: 0.609, source: "Forbes / SB XXXVIII runner-up" },
      { year: 2004, value: 0.668, source: "Forbes" },
      { year: 2005, value: 0.730, source: "Forbes" },
      { year: 2006, value: 0.838, source: "Forbes" },
      { year: 2007, value: 0.870, source: "Forbes" },
      { year: 2008, value: 0.929, source: "Forbes" },
      { year: 2009, value: 0.991, source: "Forbes" },
      { year: 2010, value: 1.04, source: "Forbes" },
      { year: 2011, value: 1.04, source: "Forbes" },
      { year: 2012, value: 1.07, source: "Forbes" },
      { year: 2013, value: 1.10, source: "Forbes" },
      { year: 2014, value: 1.25, source: "Forbes" },
      { year: 2015, value: 1.56, source: "Forbes / SB 50 runner-up" },
      { year: 2016, value: 2.08, source: "Forbes" },
      { year: 2017, value: 2.30, source: "Forbes / Tepper $2.275B acquisition" },
      { year: 2018, value: 2.30, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Panthers receive equal national share (~$340M/yr); on-field underperformance has suppressed primetime allocation throughout the post-Newton era.",
      stadium: "Bank of America Stadium (1996) is privately owned by team via stadium PSL structure; team also owns Charlotte FC (MLS) co-tenancy; renovation/replacement discussions ongoing.",
      brand: "David Tepper ownership since 2018 ($2.275B record at time); expansion 1995 franchise; Cam Newton MVP era and 2015 Super Bowl run remain peak brand moments.",
      marketSize: "Charlotte DMA #21 — fast-growing Southeast finance hub; Panthers function as Carolinas regional brand with reach into both NC and SC.",
      onField: "Bryce Young development after 2023 #1 overall pick; Dave Canales coaching second year; Carolina holding multiple high draft picks for ongoing rebuild."
    }
  },

  "New Orleans Saints": {
    extendedValuationHistory: [
      { year: 1998, value: 0.230, source: "Forbes" },
      { year: 1999, value: 0.306, source: "Forbes" },
      { year: 2000, value: 0.297, source: "Forbes" },
      { year: 2001, value: 0.371, source: "Forbes" },
      { year: 2002, value: 0.438, source: "Forbes" },
      { year: 2003, value: 0.485, source: "Forbes" },
      { year: 2004, value: 0.566, source: "Forbes" },
      { year: 2005, value: 0.626, source: "Forbes" },
      { year: 2006, value: 0.738, source: "Forbes" },
      { year: 2007, value: 0.837, source: "Forbes" },
      { year: 2008, value: 0.937, source: "Forbes" },
      { year: 2009, value: 0.955, source: "Forbes / SB XLIV champions" },
      { year: 2010, value: 0.955, source: "Forbes" },
      { year: 2011, value: 0.965, source: "Forbes" },
      { year: 2012, value: 0.965, source: "Forbes" },
      { year: 2013, value: 1.00, source: "Forbes" },
      { year: 2014, value: 1.11, source: "Forbes" },
      { year: 2015, value: 1.52, source: "Forbes" },
      { year: 2016, value: 1.75, source: "Forbes" },
      { year: 2017, value: 1.80, source: "Forbes" },
      { year: 2018, value: 2.00, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Saints receive equal national share (~$340M/yr); Drew Brees-era primetime allocation has receded post-retirement.",
      stadium: "Caesars Superdome (1975, multiple renovations) is publicly owned by Louisiana Stadium and Exposition District; iconic venue host of 7 Super Bowls including 2025 SB LIX; Caesars naming deal recent.",
      brand: "Benson family ownership (Tom Benson 1985, Gayle Benson since 2018); 2009 Super Bowl championship cemented Saints' national brand identity; Mardi Gras/Bourbon Street cultural integration.",
      marketSize: "New Orleans DMA #51 — mid-market with strong tourism economy; Saints function as Louisiana monopoly franchise with regional reach into Mississippi/Alabama.",
      onField: "Derek Carr era ended; Spencer Rattler/Tyler Shough rookie QB development; Kellen Moore HC hire 2025 marks post-Sean Payton/post-Dennis Allen reset."
    }
  },

  "Tampa Bay Buccaneers": {
    extendedValuationHistory: [
      { year: 1998, value: 0.251, source: "Forbes" },
      { year: 1999, value: 0.391, source: "Forbes" },
      { year: 2000, value: 0.502, source: "Forbes" },
      { year: 2001, value: 0.602, source: "Forbes" },
      { year: 2002, value: 0.671, source: "Forbes / SB XXXVII champions" },
      { year: 2003, value: 0.719, source: "Forbes" },
      { year: 2004, value: 0.779, source: "Forbes" },
      { year: 2005, value: 0.824, source: "Forbes" },
      { year: 2006, value: 0.903, source: "Forbes" },
      { year: 2007, value: 0.957, source: "Forbes" },
      { year: 2008, value: 1.05, source: "Forbes" },
      { year: 2009, value: 1.03, source: "Forbes" },
      { year: 2010, value: 1.03, source: "Forbes" },
      { year: 2011, value: 1.00, source: "Forbes" },
      { year: 2012, value: 1.07, source: "Forbes" },
      { year: 2013, value: 1.18, source: "Forbes" },
      { year: 2014, value: 1.33, source: "Forbes" },
      { year: 2015, value: 1.68, source: "Forbes" },
      { year: 2016, value: 1.97, source: "Forbes" },
      { year: 2017, value: 1.97, source: "Forbes" },
      { year: 2018, value: 2.00, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Buccaneers receive equal national share (~$340M/yr); Tom Brady era 2020-22 dramatically elevated primetime allocation that has since normalized.",
      stadium: "Raymond James Stadium (1998) is publicly owned by Tampa Sports Authority; Hillsborough County subsidy structure; pirate ship feature among NFL's most distinctive in-stadium attractions.",
      brand: "Glazer family ownership since 1995 ($192M); 2 Super Bowl titles (2002, 2020); Brady-era brand reset extended national appeal beyond Florida regional base.",
      marketSize: "Tampa-St. Petersburg DMA #11 — top-15 market with retiree population and corporate growth; in-state competition with Jaguars and Dolphins for Florida mindshare.",
      onField: "Baker Mayfield reset post-Brady; Mike Evans extension; Todd Bowles defensive identity; consistent NFC South contention despite division turbulence."
    }
  },

  "Arizona Cardinals": {
    extendedValuationHistory: [
      { year: 1998, value: 0.225, source: "Forbes" },
      { year: 1999, value: 0.265, source: "Forbes" },
      { year: 2000, value: 0.291, source: "Forbes" },
      { year: 2001, value: 0.349, source: "Forbes" },
      { year: 2002, value: 0.452, source: "Forbes" },
      { year: 2003, value: 0.505, source: "Forbes" },
      { year: 2004, value: 0.552, source: "Forbes" },
      { year: 2005, value: 0.612, source: "Forbes" },
      { year: 2006, value: 0.789, source: "Forbes / State Farm Stadium opened" },
      { year: 2007, value: 0.896, source: "Forbes" },
      { year: 2008, value: 0.914, source: "Forbes / SB XLIII runner-up" },
      { year: 2009, value: 0.919, source: "Forbes" },
      { year: 2010, value: 0.919, source: "Forbes" },
      { year: 2011, value: 0.939, source: "Forbes" },
      { year: 2012, value: 0.961, source: "Forbes" },
      { year: 2013, value: 1.00, source: "Forbes" },
      { year: 2014, value: 1.20, source: "Forbes" },
      { year: 2015, value: 1.61, source: "Forbes" },
      { year: 2016, value: 2.15, source: "Forbes" },
      { year: 2017, value: 2.15, source: "Forbes" },
      { year: 2018, value: 2.15, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Cardinals receive equal national share (~$340M/yr); on-field results since 2016 have constrained primetime allocation.",
      stadium: "State Farm Stadium (2006) is publicly owned by Arizona Sports & Tourism Authority; retractable roof and roll-out grass field unique; State Farm naming rights $7-9M/year; SB host venue.",
      brand: "Bidwill family ownership since 1932 — among NFL's longest continuous family ownership; founding Chicago Cardinals lineage; 2008 Super Bowl runner-up peak brand moment.",
      marketSize: "Phoenix DMA #11 — fast-growing market with snowbird/retiree demographics; in-market shares with Suns/Diamondbacks/Coyotes-now-Utah but Cardinals capture top NFL economics.",
      onField: "Kyler Murray $230M extension; Jonathan Gannon coaching staff; Marvin Harrison Jr. as foundational receiver; rebuilding under new GM regime."
    }
  },

  "Los Angeles Rams": {
    extendedValuationHistory: [
      { year: 1998, value: 0.243, source: "Forbes / St. Louis" },
      { year: 1999, value: 0.380, source: "Forbes / SB XXXIV champions; St. Louis" },
      { year: 2000, value: 0.572, source: "Forbes / St. Louis" },
      { year: 2001, value: 0.617, source: "Forbes / St. Louis" },
      { year: 2002, value: 0.677, source: "Forbes / St. Louis" },
      { year: 2003, value: 0.732, source: "Forbes / St. Louis" },
      { year: 2004, value: 0.779, source: "Forbes / St. Louis" },
      { year: 2005, value: 0.787, source: "Forbes" },
      { year: 2006, value: 0.841, source: "Forbes" },
      { year: 2007, value: 0.892, source: "Forbes" },
      { year: 2008, value: 0.929, source: "Forbes" },
      { year: 2009, value: 0.913, source: "Forbes" },
      { year: 2010, value: 0.779, source: "Forbes / Kroenke takes majority" },
      { year: 2011, value: 0.779, source: "Forbes" },
      { year: 2012, value: 0.875, source: "Forbes" },
      { year: 2013, value: 0.910, source: "Forbes" },
      { year: 2014, value: 0.930, source: "Forbes" },
      { year: 2015, value: 1.45, source: "Forbes / LA relocation announced" },
      { year: 2016, value: 2.90, source: "Forbes / LA move begins" },
      { year: 2017, value: 3.00, source: "Forbes" },
      { year: 2018, value: 3.20, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Rams receive equal national share (~$340M/yr) plus highest primetime allocation tier post-LA relocation; SoFi venue and 2021 SB championship sustain ratings premium.",
      stadium: "SoFi Stadium (2020) — $5.5B Stan Kroenke privately financed mega-venue; Kroenke retains stadium real estate, naming rights, and concert/event economics; SB LVI hosted 2022; SB LXI hosting 2027.",
      brand: "Stan Kroenke ownership since 2010 (gained majority); 2 Super Bowl titles (1999, 2021); LA relocation 2016 and McVay-era reset built modern entertainment-driven brand.",
      marketSize: "Los Angeles DMA #2 — second-largest US market shared with Chargers; Rams capture larger corporate share given Hollywood/celebrity-aligned brand.",
      onField: "Matthew Stafford era extending; Sean McVay coaching continuity; Cooper Kupp/Puka Nacua receiving corps; Aaron Donald retirement created defensive rebuild."
    }
  },

  "San Francisco 49ers": {
    extendedValuationHistory: [
      { year: 1998, value: 0.321, source: "Forbes" },
      { year: 1999, value: 0.405, source: "Forbes" },
      { year: 2000, value: 0.461, source: "Forbes" },
      { year: 2001, value: 0.528, source: "Forbes" },
      { year: 2002, value: 0.590, source: "Forbes" },
      { year: 2003, value: 0.643, source: "Forbes" },
      { year: 2004, value: 0.722, source: "Forbes" },
      { year: 2005, value: 0.718, source: "Forbes" },
      { year: 2006, value: 0.799, source: "Forbes" },
      { year: 2007, value: 0.865, source: "Forbes" },
      { year: 2008, value: 0.876, source: "Forbes" },
      { year: 2009, value: 0.865, source: "Forbes" },
      { year: 2010, value: 0.925, source: "Forbes" },
      { year: 2011, value: 0.990, source: "Forbes" },
      { year: 2012, value: 1.18, source: "Forbes" },
      { year: 2013, value: 1.22, source: "Forbes / SB XLVII runner-up" },
      { year: 2014, value: 1.60, source: "Forbes / Levi's Stadium opened" },
      { year: 2015, value: 2.70, source: "Forbes" },
      { year: 2016, value: 3.00, source: "Forbes" },
      { year: 2017, value: 3.05, source: "Forbes" },
      { year: 2018, value: 3.05, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "49ers receive equal national share (~$340M/yr) plus top-tier primetime allocation; recent Super Bowl appearances (2019, 2023 runner-up) sustain ratings premium.",
      stadium: "Levi's Stadium (2014) — $1.3B build with $850M Santa Clara Stadium Authority financing; Levi's naming rights $11M/year; concert/CFP host; co-tenant of nothing — pure NFL economics.",
      brand: "York/DeBartolo family ownership; 5 Super Bowl titles (1981-1994 dynasty); Joe Montana/Steve Young/Jerry Rice heritage; Bay Area tech/celebrity adjacent brand.",
      marketSize: "SF Bay Area DMA #8 — top-10 market with Silicon Valley corporate base; in-market shares with Raiders historically, A's; Santa Clara location splits SF/SJ corporate capture.",
      onField: "Brock Purdy as franchise QB development from 'Mr. Irrelevant'; Christian McCaffrey/Deebo/Aiyuk skill-position depth; Kyle Shanahan offensive system continuity."
    }
  },

  "Seattle Seahawks": {
    extendedValuationHistory: [
      { year: 1998, value: 0.204, source: "Forbes / Allen acquisition era" },
      { year: 1999, value: 0.310, source: "Forbes" },
      { year: 2000, value: 0.366, source: "Forbes" },
      { year: 2001, value: 0.419, source: "Forbes" },
      { year: 2002, value: 0.563, source: "Forbes / Seahawks Stadium opened" },
      { year: 2003, value: 0.603, source: "Forbes" },
      { year: 2004, value: 0.671, source: "Forbes" },
      { year: 2005, value: 0.778, source: "Forbes / SB XL runner-up" },
      { year: 2006, value: 0.880, source: "Forbes" },
      { year: 2007, value: 0.920, source: "Forbes" },
      { year: 2008, value: 1.01, source: "Forbes" },
      { year: 2009, value: 0.989, source: "Forbes" },
      { year: 2010, value: 0.989, source: "Forbes" },
      { year: 2011, value: 0.997, source: "Forbes" },
      { year: 2012, value: 1.03, source: "Forbes" },
      { year: 2013, value: 1.13, source: "Forbes / SB XLVIII champions" },
      { year: 2014, value: 1.33, source: "Forbes / SB XLIX runner-up" },
      { year: 2015, value: 1.82, source: "Forbes" },
      { year: 2016, value: 2.13, source: "Forbes" },
      { year: 2017, value: 2.43, source: "Forbes" },
      { year: 2018, value: 2.58, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Seahawks receive equal national share (~$340M/yr); 12s fan branding and Russell Wilson era sustained primetime allocation; post-Wilson era has slightly receded.",
      stadium: "Lumen Field (2002) is publicly owned by Washington State Public Stadium Authority; Lumen Technologies naming rights ~$5-7M/year; Sounders FC (MLS) co-tenant.",
      brand: "Late Paul Allen ownership (1997-2018) transformed franchise; estate-led ownership transition ongoing; 2013 Super Bowl championship and 12s fan culture peak brand moments.",
      marketSize: "Seattle DMA #12 — Pacific Northwest regional monopoly extending into Alaska and Western Canada; Amazon/Microsoft corporate base.",
      onField: "Geno Smith era to Sam Darnold transition; Mike Macdonald defensive identity (year 2); rebuilding offensive line and skill positions."
    }
  }

};
